<template>
  <form>
    <slot></slot>
  </form>
</template>

<script>
export default {
  props: {
    model: Object
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/fractel/components/vue-mc/form/mc-form.vue